import styled from 'styled-components';
import { useState, useEffect } from 'react';
// components
import ClassInfo from 'components/molecules/class/sideInfo/ClassInfo';
import Price from 'components/molecules/class/sideInfo/Price';
import Actions from 'components/molecules/class/sideInfo/Actions';
import Detail from 'components/molecules/class/sideInfo/Detail';
import ClassSideInfoSkeleton from 'components/atoms/skeletons/ClassSideInfo';
// hooks
import { useSelector } from 'hooks/common/useStore';
// utils
import { formatToPrice } from 'lib/utils/format/number';
// styles
import { palette, mediaQuery } from 'cds/styles';

/**
 * 사이드 클래스 정보
 */
const SideInfo = () => {
  const [classInfo, selectedClass] = useSelector(state => [state.class.info, state.class.selected]);
  const reviewStatis = useSelector(state => state.review.statis);
  const myId = useSelector(state => state.user.info.id);

  const [view, setView] = useState('PC');

  const isExistReview = reviewStatis.review_count > 0;

  /** 화면 넓이 리사이징에 대한 레이아웃 변경 */
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 1178) {
        setView('PC');
      } else {
        setView('Mobile');
      }
    };

    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <>
      <Layout view={view}>
        {classInfo.isLoaded && (
          <>
            {!isExistReview && (
              <EarlybirdSaleBadge>최초 오픈 할인 이벤트 진행중</EarlybirdSaleBadge>
            )}

            <ClassInfo
              classId={selectedClass.class_id}
              coachId={selectedClass.coach_id}
              photo={selectedClass.coach_photo}
              coachName={selectedClass.coach_name}
              className={selectedClass.name}
              review={{
                score: reviewStatis.review_score,
                count: formatToPrice(reviewStatis.review_count),
              }}
            />

            <Price
              salePercent={selectedClass.package_sale_per}
              originPrice={selectedClass.payment_info_data2}
              totalPrice={selectedClass.package_total_payment}
            />

            <Actions
              classId={selectedClass.id}
              remainCnt={selectedClass.groupRemain_cnt}
              isPayment={classInfo.payment_yn === 'Y'}
              isLogined={!!myId}
            />

            <Detail
              openFlag={selectedClass.open_flag}
              openDate={selectedClass.open_date}
              packageList={selectedClass.package}
              isMission={selectedClass.class_mission_cnt > 0}
            />
          </>
        )}
        {!classInfo.isLoaded && <ClassSideInfoSkeleton />}
      </Layout>
    </>
  );
};

const Layout = styled.div`
  display: none;
  position: sticky;
  top: 20px;
  right: 0px;
  width: 390px;
  margin: 20px 0 20px 24px;
  padding: 32px 20px 20px;
  border-radius: 8px;
  background-color: ${palette.white};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);

  ${mediaQuery.large} {
    display: block;
  }
`;

// TODO PHP와 임시적으로 색상 통일되어있음
const EarlybirdSaleBadge = styled.i`
  display: inline-block;
  padding: 2px 6px;
  margin-bottom: 14px;
  border: 1px solid #ff0e15;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 500;
  color: #ff0e15;
`;

export default SideInfo;
